var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 56,
    viewBox: "0 0 33 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45166 46.3925C1.45166 45.0523 1.98404 43.767 2.93168 42.8194C3.87932 41.8717 5.1646 41.3394 6.50476 41.3394H26.7172C28.0573 41.3394 29.3426 41.8717 30.2902 42.8194C31.2379 43.767 31.7703 45.0523 31.7703 46.3925V49.7612C31.7703 51.1014 31.2379 52.3866 30.2902 53.3343C29.3426 54.2819 28.0573 54.8143 26.7172 54.8143H6.50476C5.1646 54.8143 3.87932 54.2819 2.93168 53.3343C1.98404 52.3866 1.45166 51.1014 1.45166 49.7612V46.3925Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18848 48.0767V48.0932Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18848 48.0767V48.0932",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 48.0767H25.033Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 48.0767H25.033",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45166 32.9174C1.45166 31.5772 1.98404 30.2919 2.93168 29.3443C3.87932 28.3966 5.1646 27.8643 6.50476 27.8643H26.7172C28.0573 27.8643 29.3426 28.3966 30.2902 29.3443C31.2379 30.2919 31.7703 31.5772 31.7703 32.9174V36.2861C31.7703 37.6263 31.2379 38.9115 30.2902 39.8592C29.3426 40.8068 28.0573 41.3392 26.7172 41.3392H6.50476C5.1646 41.3392 3.87932 40.8068 2.93168 39.8592C1.98404 38.9115 1.45166 37.6263 1.45166 36.2861V32.9174Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18896 34.6016V34.6181Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18896 34.6016V34.6181",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 34.6016H25.033Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 34.6016H25.033",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.45166 19.4423C1.45166 18.1021 1.98404 16.8168 2.93168 15.8692C3.87932 14.9215 5.1646 14.3892 6.50476 14.3892H26.7172C28.0573 14.3892 29.3426 14.9215 30.2902 15.8692C31.2379 16.8168 31.7703 18.1021 31.7703 19.4423V22.811C31.7703 24.1512 31.2379 25.4364 30.2902 26.3841C29.3426 27.3317 28.0573 27.8641 26.7172 27.8641H6.50476C5.1646 27.8641 3.87932 27.3317 2.93168 26.3841C1.98404 25.4364 1.45166 24.1512 1.45166 22.811V19.4423Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18896 21.1265V21.143Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18896 21.1265V21.143",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 21.1265H25.033Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 21.1265H25.033",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.45166 5.96765C1.45166 4.62749 1.98404 3.34221 2.93168 2.39457C3.87932 1.44693 5.1646 0.914551 6.50476 0.914551H26.7172C28.0573 0.914551 29.3426 1.44693 30.2902 2.39457C31.2379 3.34221 31.7703 4.62749 31.7703 5.96765V9.33638C31.7703 10.6766 31.2379 11.9618 30.2902 12.9095C29.3426 13.8571 28.0573 14.3895 26.7172 14.3895H6.50476C5.1646 14.3895 3.87932 13.8571 2.93168 12.9095C1.98404 11.9618 1.45166 10.6766 1.45166 9.33638V5.96765Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18896 7.65186V7.6684Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18896 7.65186V7.6684",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 7.65186H25.033Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 7.65186H25.033",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle2);
export default __webpack_public_path__ + "static/media/single2.b5f8e3d064f9a5b9187ec3f82bcc2b49.svg";
export { ForwardRef as ReactComponent };